import request from '@/api/request'

export const getTotalStatistics = (params) => {
  return request({
    url: 'analyse/adm/baseProjectStatistics/getTotalStatistics',
    params,
    method: 'get'
  })
}

// 各项目数据
export const getProjectStatistics = (params) => {
  return request({
    url: 'admin/analyse/adm/baseProjectStatistics/getProjectStatistics',
    params,
    method: 'get'
  })
}

//  所有事业部 
export const getAvailableCompanyList = () => {
  return request({
    url: 'base/adm/company/getAvailableCompanyList',
    method: 'post'
  })
}